<template>
    <div>
        <div class="claim-title">
            理赔流程
        </div>
        <div class="claim-content">
            <div class="title">1.报案</div>
            <div class="detail">拨打平安电话<a href="tel:95511">95511</a>报案</div>
            <div class="title">2.保险公司查勘</div>
            <div class="detail">保险公司安排理赔人员现场查勘</div>
            <div class="title">3.准备材料</div>
            <div class="detail">按照保险公司要求提交索赔材料</div>
            <div class="title">4.领取赔款</div>
            <div class="detail">保险公司审核并支付赔款</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ClaimsIntro"
    }
</script>

<style scoped lang="scss">
    .claim-title{
        height: 12vw;
        padding-left: 10.67vw;
        margin-top: 2.67vw;
        line-height: 12vw;
        text-align: left;
        font-size: 4.27vw;
        font-weight: bold;
        background: url(../assets/claims.png) no-repeat 5.33vw center #ffffff;
        background-size: 4vw;
    }
    .claim-content{
        padding: 0 5.33vw 2.67vw 10.67vw;
        line-height: 8vw;
        text-align: left;
        background: #ffffff;
        .title{
            color: #333333;
            background: #ffffff;
        }
        .detail{
            color: #999999;
            /*text-indent: 5.33vw;*/
            a{
                color: #999999;
                text-decoration: none;
            }
            /*font-size: 3.2vw;*/
        }
    }
</style>
